/* eslint-disable no-console */
import App from '../../App';
import { isArray, isEmpty } from 'lodash';
const PROVIDER = 'Provider: ';
const PAYLOAD = '\nPayload:  ';
const EVENT_NAME = '\nEvent Name: ';
const PRODUCTS = 'products';
const BRAZE_ITEM_CATEGORY = 'item_category';
const BRAZE_PRODUCT_PRICE = 'item_price';
const BRAZE_CURRENCY_CODE = 'currency';
const BRAZE_QUANTITY = 'quantity';
const BRAZE_PURCHASE_PROPERTIES = 'purchaseProperties';
const EVENT_TYPE = '\nEvent Type: ';
const PRODUCT_ACTION_TYPE = '\nProduct Action Type: ';
const PROMOTION_ACTION_TYPE = '\nPromotion Action Type: ';
const EVENT_TYPE_KEY = 'eventType';
const PRODUCT_ACTION_TYPE_KEY = 'product_action_type';
const PROMOTION_ACTION_TYPE_KEY = 'promotion_action_type';
const EMAIL_KEY = 'email';
const CUSTOMER_ID_KEY = 'customerId';
const USER_ATTRIBUTES_KEY = 'userAttributes';
export const PURCHASE_EVENT_NAME = 'Product Purchased';
const GA4 = 'GA4: ';
const Braze = 'Braze: ';
const MParticle = 'MParticle: ';
const Branch = 'Branch: ';
const FullStory = 'FullStory : ';
/* istanbul ignore next */
const isDebugEnabled = (providerName) => {
    return ((App.envVars?.analyticsDebugFlag ?? false) &&
        (App.envVars?.debugAnalyticsProviders ?? '')?.toLocaleLowerCase().includes(providerName.toLocaleLowerCase()));
};
const getValue = (object, key, isRequired = false, removeItem = false) => {
    const eventType = object?.[key];
    if (eventType === undefined && isRequired) {
        throw new Error(`'${key}' is required`);
    }
    if (removeItem && object?.[key]) {
        delete object[key];
    }
    return eventType;
};
export const fsDefaultLogEventFn = async (fs, eventName, params) => {
    fs?.event(eventName, params);
    /* istanbul ignore next */
    if (isDebugEnabled('fs')) {
        /* istanbul ignore next */
        alert(PROVIDER + FullStory + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
};
export const fsLogOrderCompleted = async (fs, eventName, params) => {
    const products = getValue(params, PRODUCTS, true);
    fs?.event(eventName, params);
    if (isArray(products)) {
        products?.forEach((product) => fs?.event(PURCHASE_EVENT_NAME, product));
    }
    /* istanbul ignore next */
    if (isDebugEnabled('fs')) {
        /* istanbul ignore next */
        alert(PROVIDER + FullStory + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
};
export const ga4DefaultLogEventFn = async (ga4, eventName, params) => {
    await ga4?.logEvent(eventName, params);
    /* istanbul ignore next */
    if (isDebugEnabled('ga4')) {
        /* istanbul ignore next */
        alert(PROVIDER + GA4 + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
};
export const ga4LogoutFtn = async (ga4) => {
    await ga4?.setUserId(null);
    /* istanbul ignore next */
    if (isDebugEnabled('ga4')) {
        /* istanbul ignore next */
        alert(PROVIDER + GA4 + EVENT_NAME + 'setUserId');
    }
};
export const getGa4PredefinedFn = (eventFn) => {
    return async (ga4, _eventName, params = {}) => {
        const event = await ga4?.[eventFn]?.(params);
        /* istanbul ignore next */
        if (isDebugEnabled('ga4')) {
            /* istanbul ignore next */
            alert(PROVIDER + GA4 + EVENT_NAME + eventFn + PAYLOAD + JSON.stringify(params ?? {}));
        }
        return event;
    };
};
export const ga4SetUserId = async (ga4, eventName, params) => {
    const event = await ga4?.setUserId?.(...Object.values(params));
    if (isDebugEnabled('ga4')) {
        /* istanbul ignore next */
        alert(PROVIDER + GA4 + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return event;
};
export const brazeDefaultLogEventFn = async (braze, eventName, params) => {
    let { items } = params ?? {};
    if (!isArray(items)) {
        items = [items];
    }
    items.forEach((item) => braze?.logCustomEvent(eventName, item));
    /* istanbul ignore next */
    if (isDebugEnabled('braze')) {
        /* istanbul ignore next */
        alert(PROVIDER + Braze + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const getBrazePredefinedFn = (eventFn) => {
    return async (braze, eventName, params) => {
        const userAttributes = getValue(params, USER_ATTRIBUTES_KEY, false, true);
        if (params) {
            braze?.[eventFn]?.(...Object.values(params));
        }
        else {
            braze?.[eventFn]?.(params);
        }
        if (eventFn === 'changeUser' && userAttributes && !isEmpty(Object.keys(userAttributes))) {
            Object.entries(userAttributes).forEach(([key, value]) => {
                const attributeSetter = `set${key}`;
                braze?.[attributeSetter]?.(value);
            });
        }
        /* istanbul ignore next */
        if (isDebugEnabled('braze')) {
            /* istanbul ignore next */
            alert(PROVIDER + Braze + EVENT_NAME + eventFn + PAYLOAD + JSON.stringify(params ?? {}));
        }
        return Promise.resolve(eventName);
    };
};
export const brazeLogPurchase = async (braze, eventName, params) => {
    let products = getValue(params, PRODUCTS, true);
    const currencyCode = getValue(params, BRAZE_CURRENCY_CODE);
    if (!isArray(products)) {
        products = [products];
    }
    for (const product of products) {
        const itemCategory = getValue(product, BRAZE_ITEM_CATEGORY, true);
        const price = getValue(product, BRAZE_PRODUCT_PRICE, true);
        const quantity = getValue(product, BRAZE_QUANTITY);
        const purchaseProperties = getValue(product, BRAZE_PURCHASE_PROPERTIES) ?? [];
        braze.logPurchase(itemCategory, price, currencyCode, quantity, purchaseProperties);
    }
    /* istanbul ignore next */
    if (isDebugEnabled('braze')) {
        /* istanbul ignore next */
        alert(PROVIDER + Braze + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const brazeCustomUserAttributeFn = async (braze, eventName, params) => {
    for (const [key, value] of Object.entries(params)) {
        // noinspection TypeScriptValidateJSTypes
        await braze?.setCustomUserAttribute(key, value, () => {
            // eslint-disable-next-line no-console
            console.log(`setCustomUserAttribute(${key}, ${value}) complete!`);
        });
    }
    /* istanbul ignore next */
    if (isDebugEnabled('braze')) {
        /* istanbul ignore next */
        alert(PROVIDER + Braze + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const branchDefaultLogEventFn = async (branch, eventName, params) => {
    const branchEventName = branch.BranchEvent?.[eventName ?? ''] || eventName;
    const buos = params.buos ? await params.buos(branch?.default, params) : null;
    const eventParams = params.hasOwnProperty('eventParams') ? params?.eventParams(eventName, params) : {};
    const branchEvent = new branch.BranchEvent(branchEventName, buos, eventParams);
    await branchEvent.logEvent();
    if (isDebugEnabled('branch')) {
        /* istanbul ignore next */
        alert(PROVIDER + Branch + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const mParticleDefaultLogEventFn = async (mParticle, eventName, params) => {
    const eventType = getValue(params, EVENT_TYPE_KEY, true);
    mParticle.logEvent(eventName, eventType, params);
    /* istanbul ignore next */
    if (isDebugEnabled('mparticle')) {
        /* istanbul ignore next */
        alert(PROVIDER + MParticle + EVENT_NAME + eventName + EVENT_TYPE + eventType + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
const setTransactionAttribute = (transactionAttributeObj, attributeName, paramName, params = {}, convertToFn = '') => {
    let paramValue = params?.[paramName];
    if (paramValue !== undefined && paramValue !== null) {
        // console.log(`setting paramName: ${paramName}, paramValue: ${paramValue}, conversionFn: ${convertToFn}`);
        if (!isEmpty(convertToFn)) {
            const convertTo = window[convertToFn];
            if (typeof convertTo === 'function') {
                paramValue = convertTo(paramValue);
            }
        }
        transactionAttributeObj[attributeName] = paramValue;
    }
};
const ProductActionTypeConstants = {
    AddToCart: 1,
    RemoveFromCart: 2,
    Checkout: 3,
    CheckoutOption: 4,
    Click: 5,
    ViewDetail: 6,
    Purchase: 7,
    Refund: 8,
    AddToWishlist: 9,
    RemoveFromWishlist: 10,
};
const getMParticleProduct = (mParticle, item, params = null) => {
    const product = new mParticle.Product(item?.['item_name'], item?.['item_sku'], item?.['value'], item?.['item_quantity']);
    if (item?.['item_category']) {
        product.setCategory(item?.['item_category']);
    }
    if (item?.['item_list_name']) {
        product.setCustomAttributes({
            item_list_name: item?.['item_list_name'],
        });
    }
    if (item?.['custom_attributes']) {
        product.setCustomAttributes(item?.['custom_attributes']);
    }
    if (params?.['product_action_type'] === ProductActionTypeConstants.CheckoutOption ||
        params?.['product_action_type'] === ProductActionTypeConstants.Checkout ||
        params?.['product_action_type'] === ProductActionTypeConstants.Purchase) {
        product.setCustomAttributes({
            item_list_name: item?.['item_list_name'],
            coupon: params?.['couponCode'],
            currency: params?.['currency'],
            discount: params?.['discount'],
        });
    }
    return product;
};
export const mParticleLogCommerceEventProduct = async (mParticle, eventName, params) => {
    const productActionType = getValue(params, PRODUCT_ACTION_TYPE_KEY, true);
    const products = [];
    if (!isEmpty(params?.items)) {
        params.items.forEach((item) => {
            products.push(getMParticleProduct(mParticle, item, params));
        });
    }
    else {
        products.push(getMParticleProduct(mParticle, params));
    }
    const transactionAttributes = new mParticle.TransactionAttributes();
    setTransactionAttribute(transactionAttributes, 'transactionId', 'transaction_id', params);
    setTransactionAttribute(transactionAttributes, 'affiliation', 'affiliation', params);
    setTransactionAttribute(transactionAttributes, 'couponCode', 'couponCode', params);
    setTransactionAttribute(transactionAttributes, 'shipping', 'shipping', params, 'parseFloat');
    setTransactionAttribute(transactionAttributes, 'tax', 'tax', params, 'parseFloat');
    setTransactionAttribute(transactionAttributes, 'revenue', 'revenue', params);
    const customFlags = {};
    setTransactionAttribute(customFlags, 'GA4.CommerceEventType', 'commerceEventType', params);
    setTransactionAttribute(customFlags, 'GA4.PaymentType', 'payment_type', params);
    setTransactionAttribute(customFlags, 'GA4.ShippingTier', 'shippingTier', params);
    const event = mParticle.CommerceEvent.createProductActionEvent(productActionType, products, transactionAttributes);
    event.customFlags = customFlags;
    if (params?.['payment_type']) {
        event.setCustomAttributes({ payment_type: params?.['payment_type'] });
    }
    if (params?.['product_action_type'] === ProductActionTypeConstants.Click) {
        const cusAttributesClick = {};
        if (params?.['item_list_id'])
            cusAttributesClick['item_list_id'] = params?.['item_list_id'];
        if (params?.['content_type'])
            cusAttributesClick['content_type'] = params?.['content_type'];
        event.setCustomAttributes(cusAttributesClick);
    }
    if (params?.['currency']) {
        event.setCurrency(params?.['currency']);
    }
    if (params?.['checkout_step']) {
        event.setCheckoutStep(params?.['checkout_step']);
    }
    if (params?.['tip_selection'] || params?.['tip_amount']) {
        const cusAttributes = {};
        cusAttributes['tip_selection'] = params?.['tip_selection'];
        cusAttributes['tip_amount'] = params?.['tip_amount'];
        event.setCustomAttributes(cusAttributes);
    }
    mParticle.logCommerceEvent(event);
    /* istanbul ignore next */
    if (isDebugEnabled('mparticle')) {
        /* istanbul ignore next */
        alert(PROVIDER +
            MParticle +
            EVENT_NAME +
            eventName +
            PRODUCT_ACTION_TYPE +
            productActionType +
            PAYLOAD +
            JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const mParticleLogCommerceEventPromotion = async (mParticle, eventName, params) => {
    const promotionActionType = getValue(params, PROMOTION_ACTION_TYPE_KEY, true);
    const promotion = new mParticle.Promotion(params?.['promotion_id'], params?.['promotion_name'], params?.['creative_name'], params?.['location_id']);
    const event = mParticle.CommerceEvent.createPromotionEvent(promotionActionType, [promotion]);
    if (params?.['promotion_action_type'] === 1) {
        event.setCustomAttributes({
            user_type: params?.['user_type'],
            promo_type: params?.['promo_type'],
            disposition: params?.['disposition'],
        });
    }
    mParticle.logCommerceEvent(event);
    /* istanbul ignore next */
    if (isDebugEnabled('mparticle')) {
        /* istanbul ignore next */
        alert(PROVIDER +
            MParticle +
            EVENT_NAME +
            eventName +
            PROMOTION_ACTION_TYPE +
            promotionActionType +
            PAYLOAD +
            JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const mParticleLogCommerceEventImpression = async (mParticle, eventName, params) => {
    const product = new mParticle.Product(params?.['item_name'], params?.['item_sku'], params?.['value'], params?.['item_quantity']);
    //product.category = params?.['item_list_name'];
    if (params?.['item_category']) {
        product.setCategory(params?.['item_category']);
    }
    if (params?.['item_list_name']) {
        product.setCustomAttributes({
            item_list_name: params?.['item_list_name'],
        });
    }
    const impression = new mParticle.Impression(params?.['item_list_name'], [product]);
    const event = mParticle.CommerceEvent.createImpressionEvent([impression]);
    if (params?.['currency']) {
        event.setCurrency(params?.['currency']);
    }
    mParticle.logCommerceEvent(event);
    /* istanbul ignore next */
    if (isDebugEnabled('mparticle')) {
        /* istanbul ignore next */
        alert(PROVIDER + MParticle + EVENT_NAME + eventName + PAYLOAD + JSON.stringify(params ?? {}));
    }
    return Promise.resolve(eventName);
};
export const getMParticleAuthFn = (authFn) => {
    return async (mParticle, eventName, params) => {
        if (authFn !== 'login' && authFn !== 'logout') {
            throw new Error("Invalid auth function. Only 'login' and 'logout' are allowed");
        }
        setUserAttributeAndIdentity(mParticle, authFn, params);
        /* istanbul ignore next */
        if (isDebugEnabled('mparticle')) {
            /* istanbul ignore next */
            alert(PROVIDER + MParticle + EVENT_NAME + authFn + PAYLOAD + JSON.stringify(params ?? {}));
        }
        return Promise.resolve(eventName);
    };
};
const setUserAttributeAndIdentity = (mParticle, authFn, params) => {
    const request = new mParticle.IdentityRequest();
    if (authFn === 'login') {
        request.setEmail(getValue(params, EMAIL_KEY, true));
        request.setCustomerID(getValue(params, CUSTOMER_ID_KEY, true));
        const userAttributes = getValue(params, USER_ATTRIBUTES_KEY);
        if (userAttributes && !isEmpty(Object.keys(userAttributes))) {
            const completion = (currentUser) => {
                Object.entries(userAttributes).forEach(([key, value]) => {
                    const attrKey = mParticle.UserAttributeType[key] ?? key;
                    if (attrKey) {
                        currentUser.setUserAttribute(attrKey, value);
                    }
                });
            };
            mParticle.Identity.getCurrentUser(completion);
        }
    }
    mParticle.Identity?.[authFn]?.(request, (error, userId) => {
        if (error) {
            console.error(`mParticle ${authFn} failed; userId: ${userId}, reason: `, error);
        }
        else {
            console.debug(`mParticle ${authFn} successful; userId: ${userId}`);
        }
    });
};
export const pushFn = async (analyticsInstance, eventName, params) => {
    analyticsInstance?.push(params);
    return Promise.resolve(eventName);
};
